<template>
<div>
  <h5 class="mt-2">{{ 'RULES_GIT_SETTINGS_TITLE' | translate }}</h5>

  <div class="position-relative mt-4">
    <div v-if="loading" class="configurations-loading">
      <i class="fa fa-refresh fa-spin fa-2x text-muted" aria-hidden="true"></i>
    </div>
    <div class="form-group">
      <label for="git-url" class="control-label">{{ 'RULES_GIT_URL' | translate }}</label>
      <input type="text" id="git-url" class="form-control" disabled v-model="gitUrl">
    </div>
    <div class="form-group">
      <label for="git-url" class="control-label">{{ 'RULES_GIT_BRANCH' | translate }}</label>
      <select class="form-control form-control-sm"
              v-model="gitBranch"
              name="gitBranch"
              id="gitBranch">
        <template v-for="branch in gitBranches">
          <option :key="branch" :value="branch">
            {{ branch }}
          </option>
        </template>
      </select>

      <button class="btn btn-sm btn-block btn-primary mt-4"
              :disabled="gitBranch == gitBranchOriginal"
              @click="saveGitBranch"
      >{{ 'SAVE' | translate }}</button>
    </div>
  </div>
</div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import ConfirmDialog from '../../dialog/ConfirmDialog';

export default {
  components: { ConfirmDialog },
  props: ['rule', 'refresh'],
  data: function () {
    return {
      rest: this.initRestService(),
      loading: false,
      gitUrl: '',
      gitUrlOriginal: '',
      gitBranch: '',
      gitBranchOriginal: '',
      gitBranches: []
    }
  },
  beforeMount: function() {
    this.loadGitConfigurations();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadGitConfigurations() {
      this.loading = true;

      try {
        // The following construction is to make 3 paralel requests to the server and to wait until all are resolved (or at least one failed).
        await Promise.all([
          this.rest.getGitRepoUri().then((resp) => {
            this.gitUrl = resp.data;
            this.gitUrlOriginal = resp.data;
          }),
          this.rest.getConfiguration('rules.branch').then((resp) => {
            this.gitBranch = resp.data;
            this.gitBranchOriginal = resp.data;
          }),
          this.rest.getAvailableRulesGitBranches().then(resp => {
            this.gitBranches = resp.data;
          })
        ]);
      } catch (error) {
        this.loading = false;
        this.$log.error(error);
        this.$notify({
          type: 'alert-danger',
          duration: -1,
          text: this.$options.filters.translate('ERROR_LOADING_GIT_CONFIGURATIONS', 'msg')
        });
      }
      this.loading = false;
    },
    saveGitBranch () {
      this.loading = true;
      this.rest.setConfiguration('rules.branch', this.gitBranch).then((resp) => {
        setTimeout(() => {
          this.loading = false;
        }, 200) // This request can be very fast, this timeout gives the loader time to appear
        this.gitBranchOriginal = this.gitBranch; // now the current value becomes the new original value
        this.$emit('git-branch-changed');
        this.$notify({
          type: 'alert-success',
          text: this.$options.filters.translate('msg.BRANCH_CHANGE_SUCCESS')
        });
      }).catch((err) => {
        this.gitBranch = this.gitBranchOriginal; // revert on error
        this.loading = false;
        this.$notify({
          type: 'alert-danger',
          duration: -1,
          text: err.response.data
        });
      });
    }
  }
}
</script>

<style scoped>
  .configurations-loading {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding-top: 15px;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/rules/RulesGitConfigurations.vue